export default __webpack_public_path__ + "static/media/lorcana_promo.6e7b7691.svg";